module.exports = __webpack_public_path__ + "img/share_modle_shandong@2x.0fbb5e3c.png";